import { createFileRoute } from "@tanstack/react-router";
import { ParceriaPage } from "@/components/pages/ParceriaPage";

const SITE = "https://kentro.com.br";
const TITLE = "Kentro Partner Program — Become a partner";
const DESC =
  "Become a Kentro partner: agencies, integrators and resellers. Already a customer? Refer through Clube Indica and earn rewards.";

export const Route = createFileRoute("/$locale/parceria")({
  head: ({ params }) => {
    const loc = params.locale === "es" ? "es" : "en";
    const ogLocale = loc === "es" ? "es_ES" : "en_US";
    return {
      meta: [
        { title: TITLE },
        { name: "description", content: DESC },
        { property: "og:title", content: TITLE },
        { property: "og:description", content: DESC },
        { property: "og:url", content: `${SITE}/${loc}/parceria` },
        { property: "og:locale", content: ogLocale },
      ],
      links: [
        { rel: "canonical", href: `${SITE}/${loc}/parceria` },
        { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/parceria` },
        { rel: "alternate", hrefLang: "en", href: `${SITE}/en/parceria` },
        { rel: "alternate", hrefLang: "es", href: `${SITE}/es/parceria` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/parceria` },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: loc === "es" ? "Inicio" : "Home", item: `${SITE}/${loc}/` },
              { "@type": "ListItem", position: 2, name: 'Parcerias', item: `${SITE}/${loc}/parceria` },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": 'WebPage',
            "@id": `${SITE}/${loc}/parceria`,
            url: `${SITE}/${loc}/parceria`,
            name: TITLE,
            description: DESC,
            inLanguage: loc === "es" ? "es" : "en",
            isPartOf: { "@type": "WebSite", "@id": `${SITE}/#website` },
          }),
        },
      ],
    };
  },
  component: ParceriaPage,
});
